import SalarieDateNaissance from '@/generated/controls/salarie/SalarieDateNaissance.vue';
import { defineComponent } from "vue";

export default defineComponent({ components: {},
    extends: SalarieDateNaissance
})
